import { useCallback, useEffect, useState } from 'react';

interface IUseTextFieldMessageParams {
  correctMessage: string;
  errorMessage: string;
}

export default function usePasswordFieldMessage({
  correctMessage,
  errorMessage,
}: IUseTextFieldMessageParams): string | null {
  const [message, setMessage] = useState<string | null>(null);

  const onShowMessage = useCallback(() => {
    if (errorMessage) {
      setMessage(errorMessage);

      return;
    }

    if (correctMessage) {
      setMessage(correctMessage);

      return;
    }

    setMessage(null);
  }, [errorMessage, correctMessage]);

  useEffect(() => {
    onShowMessage();
  }, [onShowMessage]);

  return message;
}
